export function titleConverter(region, firebasedata, id) {
  const dic = {
    "sea": "Юго-Восточная Азия",
    "sinmajor": "Singapoure major",
    "animajor": "WePlay AniMajor",
    "am": "Америка",
    "china": "Китай",
    "eu_cis": "СНГ/Европа",
    "main": "Все регионы",
  }

  const fullDic = {
    ...dic,
    ...Object.entries(firebasedata).reduce((prev,curr) => {
      const [name, value] = curr;
      prev[name] = value.name;
      return prev
    }, {})
  }

  if(id) {
    for(let value of Object.values(firebasedata)){
      if(Number(value.id) === Number(id)){
        return value.name
      }
    }
  }

  return fullDic[region] ? fullDic[region] : 'Все регионы'
}
